import * as R from 'remeda';
import { GridFilterItem } from '@rossum/ui/x-data-grid-pro';
import { isEmptyValue } from '../mql/helpers';

const resolveUnorganisedFieldsInUrl = (items: GridFilterItem[]) =>
  Object.values(R.groupBy(items, item => item.field)).flat();

const replaceExistingItem = (
  existingFilterItems: GridFilterItem[],
  incomingFilters: GridFilterItem[]
) => {
  if (!incomingFilters.length) return existingFilterItems;
  // currently incomingFilters come only from one column that has an existing filter
  // so we won't be checking for undefined values later on, we know they must be there.
  const columnName = incomingFilters[0]?.field;

  // we should always make sure filters with same column come after each other in the array existingFilter.items
  // we mainly do this for possible saved bookmarks in the past
  const existingItems = resolveUnorganisedFieldsInUrl(existingFilterItems);

  const columnFirstIndex = existingItems.findIndex(
    item => item.field === columnName
  );
  const columnLastIndex = existingItems.findLastIndex(
    item => item.field === columnName
  );

  return [
    ...existingItems.slice(0, columnFirstIndex),
    ...incomingFilters,
    ...existingItems.slice(columnLastIndex + 1),
  ];
};

export const getUpdatedExistingFilter = ({
  existingFilterItems,
  incomingFilters,
  isReplaceAction,
}: {
  existingFilterItems: GridFilterItem[] | null;
  incomingFilters: GridFilterItem[];
  isReplaceAction?: boolean;
}): GridFilterItem[] => {
  if (!existingFilterItems)
    return incomingFilters.flatMap(item =>
      isEmptyValue(item.value) ? [] : [item]
    );

  if (isReplaceAction)
    return replaceExistingItem(existingFilterItems, incomingFilters);

  // add new filter if the operator does not exist
  return existingFilterItems.concat(incomingFilters);
};
